module.exports = __webpack_public_path__ + "img/img-event-tab01.7558abaa.png";